export const SET_EMPRESA_ITEM_MODULE_ACTIVE = 'SET_EMPRESA_ITEM_MODULE_ACTIVE'
export const SET_ONBOARDING_VISITED = 'SET_ONBOARDING_VISITED'

const state = {
  empresa: {
    module: {
      name: '',
    }
  },
  onboardingVisited: false,
}

const mutations = {
  [SET_EMPRESA_ITEM_MODULE_ACTIVE]: (state, module) => {
    state.empresa.module.name = module
  },
  [SET_ONBOARDING_VISITED]: (state, visited) => {
    state.onboardingVisited = visited
  },
}

const getters = {
  itemEmpresaModuleActive: state => state.empresa.module.name,
  onboardingVisited: state => state.onboardingVisited,
}

const actions = {
  setOnboardingVisited: ({ commit }, visited) => {
    commit(SET_ONBOARDING_VISITED, visited)
  },
}

export default {
  namespaced: true, state, mutations, getters, actions
}
